import MotivationalQuotesUtil from '../utils/MotivationalQuotesUtil'
import { FC } from 'react'
import { Button, Flex, Modal, Progress, Tag, Typography } from 'antd'
import { ID, WordDto, WordList } from '../../shared/types/api'
import { goToExercisePageWithReloading } from '../utils/goToPage'
import { NavigationPages } from '../../common/navigation/navigation-pages'
import { useNavigate } from 'react-router-dom'
import useTestRepeatCardLists from '../../hooks/useTestRepeatCardLists'

const { Text, Title } = Typography

interface CompletedTestDialogProps {
    open: boolean,
    cancelWindow: () => void,
    showWongWords: () => void,
    repeat: () => void,
    rightAnswers: number,
    amountWordsInTest: number,
    selectedWordListId: ID | undefined,
    wrongAnswers: Array<WordDto>
}

const CompletedTestDialog: FC<CompletedTestDialogProps> = ({
                                                               open,
                                                               cancelWindow,
                                                               repeat,
                                                               rightAnswers,
                                                               amountWordsInTest,
                                                               showWongWords,
                                                               selectedWordListId,
                                                               wrongAnswers
                                                           }) => {

    const { repeatSuggestion } = useTestRepeatCardLists(amountWordsInTest, rightAnswers, wrongAnswers, open, selectedWordListId)
    const navigate = useNavigate()

    const percent = Math.round((rightAnswers / amountWordsInTest) * 100)
    const wrongCount = amountWordsInTest - rightAnswers
    const isGreat = percent >= 80
    const strokeColor = isGreat ? '#52c41a' : percent >= 50 ? '#faad14' : '#ff4d4f'

    const openSuggestionList = (rs: WordList) => {
        cancelWindow()
        goToExercisePageWithReloading(NavigationPages.TEST, navigate, rs)
    }

    return (
        <Modal
            destroyOnClose
            open={open}
            onCancel={cancelWindow}
            centered
            title={null}
            footer={
                <Flex gap={8} justify="flex-end">
                    {wrongCount > 0 && (
                        <Button onClick={showWongWords}>Показать ошибки</Button>
                    )}
                    <Button type="primary" onClick={repeat}>Повторить</Button>
                </Flex>
            }
        >
            <Flex vertical align="center" gap={16} style={{ padding: '12px 0' }}>
                <Progress
                    type="circle"
                    percent={percent}
                    size={140}
                    strokeColor={strokeColor}
                    strokeWidth={8}
                    format={() => (
                        <Flex vertical align="center" gap={0}>
                            <span style={{ fontSize: 32, fontWeight: 700, color: 'var(--color-text)', lineHeight: 1 }}>
                                {percent}%
                            </span>
                            <span style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>
                                верно
                            </span>
                        </Flex>
                    )}
                />

                <Title level={4} style={{ margin: 0, textAlign: 'center' }}>
                    {isGreat ? 'Отличный результат!' : percent >= 50 ? 'Неплохо, но можно лучше' : 'Стоит повторить'}
                </Title>

                <Text type="secondary" style={{ textAlign: 'center' }}>
                    {rightAnswers} из {amountWordsInTest} верно
                    {wrongCount > 0 && <> · {wrongCount} {wrongCount === 1 ? 'ошибка' : 'ошибок'}</>}
                </Text>

                <Text type="secondary" style={{ textAlign: 'center', fontStyle: 'italic', fontSize: 13 }}>
                    {MotivationalQuotesUtil.generateRandomMotivationQuote()}
                </Text>
            </Flex>

            {repeatSuggestion.length > 0 && (
                <div style={{ marginTop: 8 }}>
                    <Text type="secondary">Рекомендуем повторить:</Text>
                    <Flex gap={6} wrap="wrap" style={{ marginTop: 8 }}>
                        {repeatSuggestion.map((rs) => (
                            <Tag
                                key={String(rs.id)}
                                onClick={() => openSuggestionList(rs)}
                                style={{ cursor: 'pointer' }}
                            >
                                {rs.listName}
                            </Tag>
                        ))}
                    </Flex>
                </div>
            )}
        </Modal>
    )
}

export default CompletedTestDialog
